import script from "./SalaryManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryManagement.vue?vue&type=script&setup=true&lang=js"

import "./SalaryManagement.vue?vue&type=style&index=0&id=b9131e84&lang=less&scoped=true"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9131e84"]])

export default __exports__